module.exports = __webpack_public_path__ + "img/ukraine.18ce6ce1.svg";